'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidLaptop = function IoAndroidLaptop(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.1 32.5h5.9c0 1.8-5 2.5-7.5 2.5h-25c-2.5 0-7.5-0.7-7.5-2.5h5.9c-1.8 0-3.4-1.6-3.4-3.4v-20.7c0-1.8 1.6-3.4 3.4-3.4h28.2c1.8 0 3.4 1.6 3.4 3.4v20.7c0 1.8-1.6 3.4-3.4 3.4z m-28.2-24.1v21.2h28.2v-21.2h-28.2z m14.1 25.6c0.9 0 1.6-0.8 1.6-1.7s-0.7-1.7-1.6-1.7-1.6 0.7-1.6 1.7 0.7 1.7 1.6 1.7z' })
        )
    );
};

exports.default = IoAndroidLaptop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-laptop.js
// module id = 2353
// module chunks = 168707334958949